/*
  Mobile Header/Menu
*/
// mobile menu trigger
// TEMPORARY
$(document.body).on("click", ".menu-toggle", function() {
  $(".mobile-header").toggleClass("nav-open");
  $("main").toggleClass("nav-open");
  $(".shadow_cover").toggleClass("nav-open");
  $("[class^=mob_breadcrumbs-]").toggleClass("nav-open");
  $("[class^=mob_submenu_inline-]").toggleClass("nav-open");
  $(".mob_dashboard").toggleClass("nav-open");
});

// OPEN/CLOSE SEARCH BAR //
var search_bar_listener = function() {

    var magnifier = ".search-toggle";
    var cross = ".search-toggle-open";
    var searchbar = ".search-bar-mobile";
    var voile = ".shadow_cover";


    var activate_searchbar = function() {

        $(searchbar).addClass("open"); //open searchbar
        $(voile).addClass("show"); // show voile
        $(voile).removeClass("filter"); // show voile
        $(magnifier).hide(); //hide magnifier
        $(cross).css("display", "block"); //show cross
        $(".search-bar-mobile input").focus(); //open keyboard mobile
    };

    var desactivate_searchbar = function() {

        $(searchbar).removeClass("open"); //close searchbar
        $(voile).removeClass("show"); // show voile
        $(cross).hide(); //hide cross
        $(magnifier).show(); //show magnifier
        $(".search-bar-mobile input").blur(); //close keyboard
    };



    // click on magnifier //
    $(document.body).on("click", magnifier, function(e) {

        e.preventDefault();
        activate_searchbar();
    });

    // click on cross //
    $(document.body).on("click", cross, function(e) {
        e.preventDefault();
        desactivate_searchbar();
    });

    // click on voile //
    $(document.body).on("click", voile, function() {
        desactivate_searchbar();
    });
};



// OPEN/CLOSE FILTER BAR //
var filter_bar_listener = function() {
   // click on filter trigger //
  $(document.body).on("click", mob_filter_trigger, function(e) {
      e.preventDefault();
      activate_filterbar();
  });

  // click on close //
  $(document.body).on("click", mob_filter_close, function(e) {
      e.preventDefault();
      desactivate_filterbar();
  });

  // click on voile //
  $(document.body).on("click", voile, function() {
      desactivate_filterbar();
  });

  //== get modules available for filtering
  //== if none found, hide the filter option
  var modules_available_for_filtering = $("[class^=mob][data-type=module][data-paging]");
  if (!modules_available_for_filtering.length) hide_filterbar();
};

var mob_filter_trigger = ".mob-filter-trigger";
var mob_filter_close = ".mob-filter-close";
var filterbar = ".filter-bar-mobile";
var voile = ".shadow_cover";

function activate_filterbar() {
    $(filterbar).addClass("open"); //open filterbar
    $(voile).addClass("show filter"); // show voile
    $(mob_filter_trigger).hide(); //hide magnifier
    $(mob_filter_close).show(); //show close
    $(document).blur(); //close mobile keyboard
}

function desactivate_filterbar() {
    $(filterbar).removeClass("open"); //close filterbar
    $(voile).removeClass("show"); // show voile
    $(mob_filter_close).hide(); //hide close
    $(mob_filter_trigger).show(); //show magnifier
}

function hide_filterbar() {
    $(mob_filter_trigger).hide();
}









search_bar_listener();
filter_bar_listener();
